import { Routes } from '@angular/router';

export const DEV_ROUTES: Routes = [
	{
		path: 'dev',
		children: [
			{
				path: 'config',
				loadComponent: () => import('./feature-config/config').then((m) => m.Config),
				data: { title: 'Config Dev' },
			},
			{
				path: 'estatisticas',
				loadComponent: () =>
					import('./feature-estatisticas/estatisticas').then((m) => m.Estatisticas),
				data: { title: 'Estatísticas do banco' },
			},
		],
	},
];
